// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blur {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 500;
  background-color: #FFFFFF;
  opacity: 0.5; /* Safari, Chrome and Opera > 12.1 */ /* Firefox < 16 */ /* Internet Explorer */ /* Opera < 12.1 */
  animation: fadein 0.5s;
}

mat-spinner {
  position: absolute;
  z-index: 600;
  top: calc(50% - 25px);
  left: calc(50% - 25px);
}

@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 0.5;
  }
}
/* Firefox < 16 */
/* Safari, Chrome and Opera > 12.1 */
/* Internet Explorer */
/* Opera < 12.1 */`, "",{"version":3,"sources":["webpack://./src/shared/components/loading-overlay/loading-overlay.component.scss"],"names":[],"mappings":"AAEA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA,EACA,oCAAA,EACA,iBAAA,EACC,sBAAA,EACC,iBAAA;EACG,sBAAA;AADT;;AAGA;EACI,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,sBAAA;AAAJ;;AAKA;EACI;IAAO,UAAA;EADT;EAEE;IAAO,YAAA;EACT;AACF;AACA,iBAAA;AAMA,oCAAA;AAMA,sBAAA;AAMA,iBAAA","sourcesContent":["@import '../../../assets/sass/colors';\n\n.blur{\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    z-index: 500;\n    background-color: primary-palette(100-white);\n    opacity: 0.5;\n    -webkit-animation: fadein 0.5s; /* Safari, Chrome and Opera > 12.1 */\n    -moz-animation: fadein 0.5s; /* Firefox < 16 */\n     -ms-animation: fadein 0.5s; /* Internet Explorer */\n      -o-animation: fadein 0.5s; /* Opera < 12.1 */\n         animation: fadein 0.5s;\n}\nmat-spinner{\n    position: absolute;\n    z-index: 600;\n    top: calc(50% - 25px);\n    left: calc(50% - 25px);\n\n}\n\n\n@keyframes fadein {\n    from { opacity: 0; }\n    to   { opacity: 0.5; }\n}\n\n/* Firefox < 16 */\n@-moz-keyframes fadein {\n    from { opacity: 0; }\n    to   { opacity:  0.5; }\n}\n\n/* Safari, Chrome and Opera > 12.1 */\n@-webkit-keyframes fadein {\n    from { opacity: 0; }\n    to   { opacity:  0.5;  }\n}\n\n/* Internet Explorer */\n@-ms-keyframes fadein {\n    from { opacity: 0; }\n    to   { opacity:  0.5;  }\n}\n\n/* Opera < 12.1 */\n@-o-keyframes fadein {\n    from { opacity: 0; }\n    to   { opacity:  0.5;  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
